/**
 * @providesModule LiveEventFTUEFlowController
 *
 */

// TODO (websdk-ms-2-phase-ftue)
const LiveEventFTUEFlowController = {
  resetState: () => {
    console.log('WebSDK: LiveEventFTUEFlowController.resetState() MOCK USED');
  },
  isInFlow: () => {
    console.log('WebSDK: LiveEventFTUEFlowController.isInFlow() MOCK USED');
  },
};

export default LiveEventFTUEFlowController;
